<template>
	<section>
		<h5 class="flex justify-between items-center">
			<span v-html="$parent.label('screenshots', 'Screenshots')"></span>

			<span
				v-show="!showScreenshotUploader"
				title="Add Screenshot"
				class="text-primary"
				@click="showScreenshotUploader = true"
			>
				<i class="fa fa-plus-circle text-2xl"></i>
			</span>
		</h5>

		<form v-show="showScreenshotUploader" id="upload-screenshot" class="relative flex flex-col border border-gray-200mt-3 mb-0">
			<div class="header-row border-b border-gray-200 capitalize flex justify-between items-center">
				<span>Add Screenshot</span>

				<span @click="showScreenshotUploader = false" title="Hide Uploader">
					<i class="fa fa-times"></i>
				</span>
			</div>

			<input type="hidden" name="_token" :value="csrfToken" readonly/>
			<input type="hidden" name="ats-id" :value="atsId" readonly/>

			<div class="card-body add-screenshots">
				<div class="flex items-end">
					<select name="type" class="form-control mr-2 w-180p" @change="$parent.screenshotChange" required>
						<option v-for="type in Object.keys($parent.ats.screenshots)" :value="type">
							{{ ucFirst(type) }} Screenshot
						</option>
					</select>

					<input
						type="text"
						name="title"
						class="form-control py-1 px-3 w-full flex-shrink-1"
						placeholder="Title (required)"
						required
						@change="$parent.screenshotChange"
					/>

					<label class="flex items-center w-130p shrink-0">
						<input
							type="checkbox"
							name="internal"
							class="mx-2"
							value="1"
							@change="$parent.screenshotChange"
						/>

						<span>Internal Only</span>
					</label>
				</div>

				<textarea
					name="description"
					class="form-control py-2 px-3 mt-2"
					placeholder="Description (optional)"
					@change="$parent.screenshotChange"
				></textarea>

				<div class="flex items-center mt-2">
					<input
						type="file"
						name="screenshot"
						accept="image/*"
						class="form-control p-1 w-full flex-shrink-1"
						required
						@change="$parent.screenshotChange"
					/>

					<button
						:class="`btn btn-${$parent.disableUpload() ? 'secondary' : 'primary'} ml-2 flex items-center w-130p`"
						:disabled="$parent.disableUpload() ? 'disabled' : false"
						@click.prevent="$parent.uploadScreenshot"
					>
						<i class="fa fa-upload"></i> <span>Upload</span>
					</button>
				</div>
			</div>
		</form>

		<div v-for="(images, type) in $parent.ats.screenshots" :key="type" class="relative flex flex-col border border-gray-200mt-3 mb-0">
			<div class="header-row border-b border-gray-200 capitalize">{{ type }} Screenshots</div>

			<div class="card-body">
				<div v-if="Object.keys(images).length" class="row flex-wrap">
					<div
						v-for="(img, src) in images"
						:key="`${type}-${src}`"
						class="screenshot-thumb relative pointer"
						:style="`background-image: url('${src}')`"
						:title="`${img.title}\n${img.description ? img.description + '\n' : ''}(Click to preview)`"
						@click.prevent.stop="previewScreenshot(src, img)"
					>
						<span class="absolute">
							<span title="Remove" class="pointer" @click.prevent.stop="confirmRemove = src">
								<i class="fa fa-times-circle"></i>

								<confirm-box
									:show="confirmRemove === src"
									:content="`Are you sure you want to remove this screenshot?`"
									button="Delete"
									@cancel="confirmRemove = false"
									@confirm="$parent.removeScreenshot(type, src); confirmRemove = false"
								/>
							</span>
						</span>
					</div>
				</div>

				<div v-else>
					<strong>No Screenshots</strong>
				</div>
			</div>
		</div>

		<modal-overlay
			:active="showScreenshotPreviewer"
			:header="`Screenshot Preview - ${showScreenshotPreviewer.title}${showScreenshotPreviewer.internal ? ' (internal only)' : ''}`"
			confirm="Open in New Tab"
			cancel="Close"
			@cancel="showScreenshotPreviewer = false"
			@confirm="openScreenshot(showScreenshotPreviewer.src)"
		>
			<img :src="showScreenshotPreviewer.src" alt="screenshot preview" class="m-auto border" style="max-width: 100%"/>

			<div v-if="showScreenshotPreviewer.description" class="mt-4 text-center">
				<h5>Screenshot Description</h5>

				<p>{{ showScreenshotPreviewer.description }}</p>
			</div>
		</modal-overlay>
	</section>
</template>

<script>
export default {
	name: "AtsScreenshots",
	props: {
		atsId: {type: Number, required: true}
	},
	data() {
		return {
			csrfToken: null,
			localScreenshots: [],
			confirmRemove: false,
			showScreenshotUploader: false,
			showScreenshotPreviewer: false,
		};
	},
	methods: {
		ucFirst(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		},
		setCsrfToken() {
			const $csrfInput = jQuery('meta[name=csrf-token]');

			if ($csrfInput.length) this.csrfToken = $csrfInput.val();
		},
		previewScreenshot(scr, img) {
			this.showScreenshotPreviewer = {
				src: scr,
				title: img.title,
				description: img.description,
				internal: img.internal || false,
			};
		},
		openScreenshot(src) {
			window.open(src, '_blank');

			this.showScreenshotPreviewer = false;
		}
	},
	created() {
		this.setCsrfToken();
	}
}
</script>

<style scoped lang="scss">
	.screenshot-thumb {
		width: calc(25% - 2rem);
		height: 10vw;
		margin: 1rem;
		border: .5rem solid white;
		box-shadow: 0 0 2px rgba(black, .3), inset 0 0 2px rgba(black, .2);
		background-repeat: no-repeat;
		background-size: cover;
		color: #222;

		span.absolute {
			top: -1rem;
			right: -.75rem;
			transition: opacity .3s;
		}

		@media (max-width:1279px) {
			width: calc(33.333% - 2rem);
			height: 15vw;
		}

		@media (max-width:999px) {
			width: calc(50% - 2rem);
			height: 20vw;
		}

		@media (max-width:799px) {
			width: calc(100% - 2rem);
			height: 35vw;
		}
	}

	input[name=screenshot] {
		opacity: .75;
		border-color: rgba(black, .25);
	}
</style>